import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {UpdateCitizenPassword} from './update-citizen-password.model';
import * as UpdateCitizenPasswordActions from './update-citizen-password.actions';

export const updateCitizenPasswordsFeatureKey = 'updateCitizenPasswords';

export interface State extends EntityState<UpdateCitizenPassword> {
  // additional entities state properties
}

export const adapter: EntityAdapter<UpdateCitizenPassword> = createEntityAdapter<UpdateCitizenPassword>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(UpdateCitizenPasswordActions.addUpdateCitizenPassword,
    (state, action) => adapter.addOne(action.updateCitizenPassword, state)
  ),
  on(UpdateCitizenPasswordActions.upsertUpdateCitizenPassword,
    (state, action) => adapter.upsertOne(action.updateCitizenPassword, state)
  ),
  on(UpdateCitizenPasswordActions.addUpdateCitizenPasswords,
    (state, action) => adapter.addMany(action.updateCitizenPasswords, state)
  ),
  on(UpdateCitizenPasswordActions.upsertUpdateCitizenPasswords,
    (state, action) => adapter.upsertMany(action.updateCitizenPasswords, state)
  ),
  on(UpdateCitizenPasswordActions.updateUpdateCitizenPassword,
    (state, action) => adapter.updateOne(action.updateCitizenPassword, state)
  ),
  on(UpdateCitizenPasswordActions.updateUpdateCitizenPasswords,
    (state, action) => adapter.updateMany(action.updateCitizenPasswords, state)
  ),
  on(UpdateCitizenPasswordActions.deleteUpdateCitizenPassword,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(UpdateCitizenPasswordActions.deleteUpdateCitizenPasswords,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(UpdateCitizenPasswordActions.loadUpdateCitizenPasswords,
    (state, action) => adapter.setAll(action.updateCitizenPasswords, state)
  ),
  on(UpdateCitizenPasswordActions.clearUpdateCitizenPasswords,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
